import { action, observable, makeObservable } from 'mobx';
import {SuccessResponse, TimeZone, timeZoneLoaders} from '../../../domain';
import {HttpPromiseState} from '../../../lib/helpers';

export class DeleteTimeZoneStore {
  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly timeZone: TimeZone) {
    makeObservable(this);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.save = timeZoneLoaders.delete(this.timeZone.Id);
  }
}
